<div class="footer-wrapper bg-shs-gray-5 fixed bottom-0 left-0 right 0 w-full z-10">
    <div class="footer text-shs-white-1 text-xs flex gap-4 p-4 border-t border-shs-gray-4">
        <div>© Siemens Healthcare GmbH 2026</div>
        <a class="footer-link" target="_blank" [href]="'https://www.siemens-healthineers.com/corporate-info'"
            >Corporate Information</a
        >
        <a
            class="footer-link"
            target="_blank"
            [href]="'https://www.siemens-healthineers.com/siemens-website-privacy-policy'"
            >Privacy Policy</a
        >
        <a class="footer-link" target="_blank" [href]="'https://www.siemens-healthineers.com/cookie'">Cookie Policy</a>
        <a class="footer-link" target="_blank" [href]="'https://www.siemens-healthineers.com/terms-of-use'"
            >Terms of Use</a
        >
        <a
            class="footer-link"
            target="_blank"
            [href]="'https://www.siemens-healthineers.com/corporate/digital-services-act'"
            >Digital Service Act</a
        >
        <a class="footer-link" target="_blank" [href]="'https://healthcare.service-now.com/serviceport?id=index_hc'"
            >Help</a
        >
    </div>
</div>
